<script>
  export default {
    name: 'ConfirmModal',
    props: ['next', 'sign', 'accept', 'name'],
    data() {
      return {
        isModalVisible: false,
        //nextURL: "",
        //signURL: "",
        //acceptURL: "",
      }
    },
    methods: {
      closeYes() {
        this.$emit('close');
      },
      refresh(){
        window.location.reload;
      },
      closeNo() {
        this.$emit('close');
      }
    },
    mounted(){
      $(this.$refs.vuemodal).on("hidden.bs.modal", this.refresh)
    }
  };
</script>

<template @hidden="refresh()">
  <div class="modal fade" @hide="refresh" tabindex="-1" role="dialog">
    <div class="modal-dialog" @hide="refresh" @hidden="refresh()" ref="vuemodal">
      <div class="modal-content">
        <div class="modal-body" style="color:black;text-align:center;">
          <slot name="body">
            <p style="white-space: break-spaces;text-transform: none;">
              {{ $t('javascript.confirm_modal.nobody_is_here') }}
            </p>
          </slot>
        </div>

        <div class="modal-footer" style="text-align: center;">
          <button
            type="button"
            class="btn btn-primary btn-nomargin"
            @click="closeYes"
          >
            {{ $t('javascript.confirm_modal.ok') }}
          </button>
          <br>

        </div>
      </div>
    </div>
  </div>
</template>


